import { useState, useRef, useEffect } from "react";
import { SummaryFolder } from "../components/summary_folder";
import { SummaryTape } from "../components/summary_tape";
import { PrefixClasz } from "../components/prefix_class";
import { Container } from "react-bootstrap";

export const PoolFlow = (props) => {
    const [parent, setParent] = useState();
    const [winWidth, setWinWidth] = useState(1000);
    const [rowCount, setRowCount] = useState();
    const [refresh, setRefresh ] = useState(true);

    const codeRef = useRef();

    const followSub = (e) => {
        let tar = e.currentTarget.textContent.replace("/", "_");
        window.location.href = "/act/app/subnet/" + tar;
    }

    const getFormat = (tag) => {
        switch (tag) {
            case 'f':
                return 'folder';
            case 'x':
                return 'text-contrast';
            default:
                return ''
        }
    }

    const updatePrefixes = (p) => {
        setParent(null);
        props.setPrefixes(p);
    }

    const setFocusNode = (node) => {
        if (node == null) {
            setParent(null);
            return;
        }
        let nets = props.nets.nodes.map(p => {
            return new PrefixClasz(p);
        });
        let result = [];
        if (nets[0].is4())
            nets.forEach(n => {
                result = n.findPath4(node, result);
            });
        else
            nets.forEach(n => {
                result = n.findPath6(node, result);
            });
        result.reverse();
        setParent(result);
    }

    useEffect(() => {
        if (codeRef.current) {
            let panel = codeRef.current.parentNode.parentNode.clientWidth - 58;
            let codeNode = codeRef.current.parentNode.getElementsByTagName("code")[0].getBoundingClientRect().width;
            setWinWidth(panel - codeNode);
            setRefresh(false);
            setRowCount(props.nets.nodes[0].members.length)
        }
    }, [props.nets, refresh]);

    return <>
        <pre className="half-panel inline">
            <code ref={codeRef}>
                {props.nets && codeRef.current &&
                    props.nets.nodes.map((subnet, id) => {
                        return (
                            <SummaryFolder rowCount={rowCount} setRefresh={setRefresh} refresh={props.nets} canvasRef={codeRef} key={id} folder={subnet} />
                        );
                    })}
            </code>
            <svg width={winWidth}>
                {props.nets && codeRef.current &&
                    props.nets.nodes.map((subnet, id) => {
                        return (
                            <SummaryTape parents={{ parent: parent, setFocusNode: setFocusNode }} winWidth={winWidth - 25} refresh={refresh} key={id} folder={subnet} root={true} box={{ x: 0.0, w: 1.0 }} parentY={0} />
                        );
                    })}
            </svg>
        </pre>
        {props.nets.message.length > 0 ? <div>
            <Container><div className="err">Pool Exhausted: {props.nets.message}.</div></Container>
        </div> : null}
        {props.nets && codeRef.current &&
        <Container class="docs half-panel mt-3">
            <h5>Allocations</h5>
            <div id="alloc" className="inline half-panel min70">
            <pre>
                {props.nets.nodes[0].members.filter(subnet =>
                    subnet.tag === "."
                ).map(s =>
                    <div className="fs-6">{s.prefix}</div>
                )
                }
            </pre>
            </div>
             <div className="inline half-panel min70">
            <pre>
                {props.nets.nodes[0].members.filter(subnet =>
                    subnet.tag === "."
                ).map(s =>
                    <div className="fs-6">{s.longForm}</div>
                )
                }
            </pre>
            </div>
            </Container>
        }
    </>
}